function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotelPackageFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.061 5.253c-.539-.31-1.439-.582-2.713-.118L16.1 6.515l-6.968-4.31a.904.904 0 00-.948-.003l-1.137.696a.903.903 0 00-.242 1.329L10.5 8.975l-.005.003 1.145 1.462 1.782-.66-4.188-5.381 6.312 3.904a.902.902 0 00.831.064l3.636-1.547c.468-.171.845-.168 1.151.006.388.222.598.678.648.95-.025.105-.242.342-1.492.795L6.663 13.54a1.355 1.355 0 00-.123.056c-.408.215-.532.01-.579-.068-.28-.468-.693-1.255-1.053-1.96l1.373.852a.913.913 0 00.85.057l3.38-1.521-1.152-1.47-2.533 1.14L4.76 9.346a.907.907 0 00-.787-.082l-.943.342a.904.904 0 00-.504 1.249c.05.103 1.241 2.54 1.883 3.609.465.77 1.147 1.034 1.79 1.034.424 0 .83-.115 1.143-.275l6.848-2.493a.364.364 0 00.032-.012l.007-.002 6.79-2.472c.867-.313 2.9-1.05 2.57-2.82-.124-.67-.599-1.641-1.528-2.171zM21.5 22.008h3v-2h-3v2zM19.5 22.008h-3v-2h3v2zM21.5 26.008h3v-2h-3v2zM19.5 26.008h-3v-2h3v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 28V16.008h-3v-2h-10v2h-3V28h-2v2h20v-2h-2zm-14 0h12v-9.992h-12V28z",
    fill: props.color
  }));
}

export default SvgIconHotelPackageFilled;